import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../components/private/pagination";

const Proposal = () => {

  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);

  // FILTROS
  const [populationFilter, setPopulationFilter] = useState("");
  const [startFilter, setStartFilter] = useState("");
  const [endFilter, setEndFilter] = useState("");

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =====================================================
  // CARGAR PROPUESTAS
  // =====================================================

  useEffect(() => {

    if (!token) return;

    const loadProposals = async () => {

      setLoading(true);

      try {

        const data = await authFetch(ENDPOINTS.getProposal);

        if (data.success && data.proposals) {
          setProposals(data.proposals);
        } else {
          setProposals([]);
        }

      } catch (error) {
        console.error("Error cargando propuestas:", error);
        setProposals([]);
      }

      setLoading(false);

    };

    loadProposals();

  }, [token, authFetch]);

  // =====================================================
  // FILTROS
  // =====================================================

  const filteredProposals = proposals.filter((proposal) => {

    const matchesPopulation =
      populationFilter === "" ||
      proposal.type_population?.toLowerCase().includes(populationFilter.toLowerCase());

    const matchesStart =
      startFilter === "" ||
      proposal.start_date >= startFilter;

    const matchesEnd =
      endFilter === "" ||
      proposal.end_date <= endFilter;

    return matchesPopulation && matchesStart && matchesEnd;

  });

  // =====================================================
  // PAGINACIÓN
  // =====================================================

  const totalPages = Math.ceil(filteredProposals.length / recordsPerPage);

  const currentProposals = filteredProposals.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {

    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }

  };

  // =====================================================
  // RENDER
  // =====================================================

  if (loading) return <p>Cargando propuestas...</p>;

  return (

    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-3">

        <h2>Lista de Propuestas</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/mod_proyectos/proposal/createProposal")}
        >
          <i className="bi bi-plus-circle me-1"></i>
          Crear Propuesta
        </button>

      </div>

      {/* FILTROS */}

      <div className="row mb-3">

        <div className="col-md-4">

          <label className="m-1">Tipo de población</label>

          <input
            type="text"
            className="form-control"
            value={populationFilter}
            onChange={(e) => {
              setPopulationFilter(e.target.value);
              setCurrentPage(1);
            }}
          />

        </div>

        <div className="col-md-3">

          <label className="m-1">Fecha inicio</label>

          <input
            type="date"
            className="form-control"
            value={startFilter}
            onChange={(e) => {
              setStartFilter(e.target.value);
              setCurrentPage(1);
            }}
          />

        </div>

        <div className="col-md-3">

          <label className="m-1">Fecha fin</label>

          <input
            type="date"
            className="form-control"
            value={endFilter}
            onChange={(e) => {
              setEndFilter(e.target.value);
              setCurrentPage(1);
            }}
          />

        </div>

      </div>

      {/* TABLA */}

      {currentProposals.length > 0 ? (

        <>
          <table className="table table-hover">

            <thead className="table-secondary">
              <tr>
                <th>Entidad</th>
                <th>Tipo población</th>
                <th>Municipios</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>

              {currentProposals.map((proposal) => (

                <tr key={proposal.id_proceso}>

                  <td>{proposal.entidad}</td>
                  <td>{proposal.type_population}</td>
                  <td>{proposal.municipality}</td>
                  <td>{proposal.start_date}</td>
                  <td>{proposal.end_date}</td>

                  <td>
                    {Number(proposal.state) === 1
                      ? "Activo"
                      : "Inactivo"}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary m-1"
                      onClick={() =>
                        navigate(`/session/mod_proyectos/proposal/viewProposal/${proposal.id_proceso}`)
                      }
                    >
                      <i className="bi bi-eye"> Detalle</i>
                    </button>

                    <button
                      className="btn btn-sm btn-outline-purple"
                      onClick={() =>
                        navigate(`/session/mod_proyectos/proposal/updateProposal/${proposal.id_proceso}`)
                      }
                    >
                      <i className="bi bi-pencil-square me-1"> Modificar</i>
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>

      ) : (

        <p>No hay propuestas registradas.</p>

      )}

    </div>

  );

};

export default Proposal;